<template>
  <div class="mps-admin-widgets vue-rqf bg-loading" :loading="$root.ui.loading">
    <div class="mps-widgets-columns">
      <div class="mps-widgets-column">
        <div v-if="workshops.length" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>Verksteder</h4>
          </header>
          <div class="mps-admin-padding">
            <ul class="mps-admin-list">
              <template v-for="(ws, wsIdx) in workshops">
                <li :status="ws.status" class="mps-entity-item">
                  <span v-text="ws.name"></span>
                  <a :href="'#/workshop/'+ws.id">Rediger</a>
                </li>
              </template>
            </ul>
          </div>
          <footer v-if="$root.isAdminUser()" class="mps-admin-padding">
            <a href="#/workshop" class="mps-admin-btn">Legg til</a>
          </footer>
        </div>
        <div v-if="workshopInfo" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>Verksted kontaktinfo</h4>
          </header>
          <div class="mps-admin-padding">
            <ul class="mps-admin-list">
              <li class="mps-highlight"><b v-text="workshopInfo.name"></b></li>
              <li><span v-text="workshopInfo.email"></span></li>
              <li><span v-text="workshopInfo.phone"></span></li>
              <li><span v-text="workshopInfo.street"></span></li>
              <li><span v-text="workshopInfo.postal + ' ' + workshopInfo.city"></span></li>
              <li><span v-text="workshopInfo.county"></span></li>
              <li><b>Kart:</b></li>
              <li><span v-text="'Longitude: ' + (workshopInfo.longitude+0)"></span></li>
              <li><span v-text="'Latitude: ' + (workshopInfo.latitude+0)"></span></li>
            </ul>
          </div>
          <footer class="mps-admin-padding">
            <a :href="'#/workshop/' + workshopInfo.id" class="mps-admin-btn">Rediger</a>
          </footer>
        </div>
        <div v-if="$root.isAdminUser() && companies.length" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>Companies</h4>
          </header>
          <div class="mps-admin-padding">
            <ul class="mps-admin-list">
              <template v-for="(c, wsIdx) in companies">
                <li :status="c.status" :partner="c.is_partner" :fleet="c.is_fleet" class="mps-entity-item">
                  <span v-text="c.name + (c.type_slug ? ' (' + c.type_slug + ')' : '')"></span>
                  <a :href="'#/company/'+c.id">Rediger</a>
                </li>
              </template>
            </ul>
          </div>
          <footer class="mps-admin-padding">
            <a href="#/company" class="mps-admin-btn">Legg til</a>
          </footer>
        </div>
    <!--
        <div v-if="fleetpartners.length" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>Fleet Partnere</h4>
          </header>
          <div class="mps-admin-padding">
            <ul class="mps-admin-list">
              <template v-for="(ws, wsIdx) in fleetpartners">
                <li :status="ws.status" class="mps-entity-item">
                  <span v-text="ws.name"></span>
                  <a :href="'#/fleetpartner/'+ws.id">Rediger</a>
                </li>
              </template>
            </ul>
          </div>
          <footer class="mps-admin-padding">
            <a href="#/fleetpartner" class="mps-admin-btn">Legg til</a>
          </footer>
        </div>
        -->
        <!--
        <div v-if="fleetpartnerInfo" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>Fleet partner kontaktinfo</h4>
          </header>
          <div class="mps-admin-padding">
            <ul class="mps-admin-list">
              <li class="mps-highlight"><b v-text="fleetpartnerInfo.name"></b></li>
              <li><span v-text="fleetpartnerInfo.email"></span></li>
              <li><span v-text="fleetpartnerInfo.phone"></span></li>
              <li><span v-text="fleetpartnerInfo.street"></span></li>
              <li><span v-text="fleetpartnerInfo.postal + ' ' + fleetpartnerInfo.city"></span></li>
              <li><span v-text="fleetpartnerInfo.county"></span></li>
              <li><b>Kart:</b></li>
              <li><span v-text="'Longitude: ' + (fleetpartnerInfo.longitude+0)"></span></li>
              <li><span v-text="'Latitude: ' + (fleetpartnerInfo.latitude+0)"></span></li>
            </ul>
          </div>
          <footer class="mps-admin-padding">
            <a :href="'#/fleetpartner/' + fleetpartnerInfo.id" class="mps-admin-btn">Rediger</a>
          </footer>
        </div>
       -->
      </div>
      <div class="mps-widgets-column">
        <div v-if="requests.length" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>Prisforespørsler</h4>
          </header>
          <div class="mps-admin-padding">
            <template v-for="(request,requestIndex) in requests">
              <a target="_blank" :href="requestsNewUri + '/request/admin/' + request.code" class="mps-admin-widget-item">
                <div>
                  <b class="mps-highlight" v-text="request.contact_name"></b>
                  <br>
                  <span class="upcase" v-text="(request.car_id ? request.car_id : '') + (request.car_model ? (' - ' + request.car_producer + ' ' + request.car_model + ' ' + request.car_year) : '')"></span>
                </div>
                <div>
                  <span v-text="request.date"></span>
                  <span v-text="request.time"></span>
                </div>
              </a>
            </template>
          </div>
          <footer class="mps-admin-padding">
            <a :href="requestsNewUri" class="mps-admin-btn">Ny hurtigtakst</a>
            <a :href="requestsAllUri">Vis alle</a>
          </footer>
        </div>
        <div v-if="reports.length" class="mps-admin-widget">
          <header class="mps-admin-padding">
            <h4>PreTakst</h4>
          </header>
          <div class="mps-admin-padding">
            <template v-for="(report,reportIndex) in reports">
              <a target="_blank" :href="reportsAllUri + '/' + report.id" class="mps-admin-widget-item">
                <div>
                  <b class="mps-highlight" v-text="report.surveyor_name"></b>
                  <br>
                  <span class="upcase" v-text="report.car_id"></span>
                </div>
                <div>
                  <span v-text="report.date"></span>
                  <span v-text="report.time"></span>
                </div>
              </a>
            </template>
          </div>
          <footer class="mps-admin-padding">
            <a :href="reportsNewUri" class="mps-admin-btn">Ny takst</a>
            <a :href="reportsAllUri">Vis alle</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      reports: [],
      reportsAllUri: '',
      reportsNewUri: '',
      requests: [],
      requestsAllUri: '',
      requestsNewUri: '',
      workshopInfo: null,
      workshops: [],
      companies: []
      //fleetpartnerInfo: null,
      //fleetpartners: []
    }
  },
  methods: {
    getWidgetsData(){
      var self = this
      self.$root.ui.loading = true;
      self.$api.getWidgetsData().then(function(data){
        self.$root.ui.loading = false;
        self.reports = data.reports;
        self.reportsAllUri = data.reportsAllUri;
        self.reportsNewUri = data.reportsNewUri;
        self.requests = data.requests;
        self.requestsAllUri = data.requestsAllUri;
        self.requestsNewUri = data.requestsNewUri;
        if(data.workshopInfo)
          self.workshopInfo = data.workshopInfo;

        if(data.workshops)
          self.workshops = data.workshops;
        if(data.companies)
          self.companies = data.companies;
        //if(data.fleetpartnerInfo)
        //  self.fleetpartnerInfo = data.fleetpartnerInfo;
          

        //if(data.fleetpartners)
        //  self.fleetpartners = data.fleetpartners;

      })
    }
  },
  created(){
    this.getWidgetsData()
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Widgets.vue?63072178